import PropTypes from 'prop-types';
import {Table} from 'semantic-ui-react';

import ShortUrlsListItem from './ShortUrlsListItem';

import styles from './ShortUrlsList.module.scss';

const ShortUrlsList = ({shortUrls}) => {
  return (
    <Table stackable celled className={styles.ShortUrlsList}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={5}>Short URL</Table.HeaderCell>
          <Table.HeaderCell width={7}>Target URL</Table.HeaderCell>
          <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {shortUrls.map(url => (
          <ShortUrlsListItem key={url.id} shortUrl={url} />
        ))}
      </Table.Body>
    </Table>
  );
};

ShortUrlsList.propTypes = {
  shortUrls: PropTypes.array.isRequired,
};

export default ShortUrlsList;
